import { cloneDeep, every, filter, isEmpty, map, uniq } from 'lodash';

import { IEventBreakdown, IEventFilter, ISankeyRequestBody } from '@src/emp-3.0/types';

export function mergeEventsFilterArrays(
  landing_events_filters: IEventFilter[][],
  breakdowns: IEventFilter[][],
): IEventFilter[][] {
  return breakdowns.map((breakdown: IEventFilter[]) => {
    const matchingSubArrayA = landing_events_filters.find((subArrayA: IEventFilter[]) => {
      return subArrayA[0].field === breakdown[0].field;
    });

    if (matchingSubArrayA) {
      if (breakdown[0].value) {
        breakdown[0].value = uniq([...breakdown[0].value, ...matchingSubArrayA[0].value]);
      } else {
        breakdown[0].value = [...matchingSubArrayA[0].value];
      }
    }

    return breakdown;
  });
}

export const trimEventFilter = (eventFilter: IEventFilter[][]): IEventFilter[][] => {
  return filter(eventFilter, (filterGroup) => {
    return every(filterGroup, (filterItem) => {
      return filterItem.field !== '' && !isEmpty(filterItem.value);
    });
  });
};

export const generateLandingEventFilters = (
  event_breakdown: IEventBreakdown[],
  eventName: string,
) => {
  const foundSameEventBreakdown = event_breakdown.find((item) => item.event_name === eventName);
  return map(foundSameEventBreakdown?.breakdowns ?? [], (breakdown) => {
    return [
      {
        field: breakdown[0].field,
        value: [],
        op: breakdown[0].op,
        is_all: breakdown[0].is_all,
      },
    ];
  });
};

export const generateAutoBreakdownEventFilters = (
  landingEventFilter: IEventFilter[][],
  breakdowns: IEventFilter[][],
): IEventFilter[][] => {
  const copiedLandingEventFilter = cloneDeep(landingEventFilter);
  return map(copiedLandingEventFilter, (filterGroup) => {
    return map(filterGroup, (filterItem) => {
      const findSameDimension = breakdowns.find((item) => item[0].field === filterItem.field);
      const dimensionValue = findSameDimension?.[0].value ?? [];

      if (filterItem.field !== '' && !isEmpty(filterItem.value)) {
        if (dimensionValue.length === 0) {
          return { ...filterItem, value: [], is_all: true };
        } else {
          const includedValue = dimensionValue?.includes(filterItem.value[0]);
          const updatedValue = includedValue
            ? dimensionValue
            : [...filterItem.value, ...dimensionValue];
          return { ...filterItem, value: updatedValue, is_all: false };
        }
      }
      return filterItem;
    });
  });
};

export const removeSankeyEmptyFilters = (payload: ISankeyRequestBody) => {
  const copiedPayload = cloneDeep(payload);
  const { interval } = copiedPayload;
  if (!interval) {
    return;
  }
  // remove empty filters
  copiedPayload.filters = copiedPayload.filters.filter(
    (item) => item.filter((x) => x.value.length).length,
  );
  // remove empty breakdown from landing events
  copiedPayload.landing_events[0].filters = copiedPayload.landing_events[0].filters.filter(
    (item) => item.filter((y) => y.value.length).length,
  );
  // remove empty filters in breakdowns
  // @ts-ignore
  copiedPayload.event_breakdown = copiedPayload.event_breakdown
    .map((item) => {
      item.breakdowns = item.breakdowns.filter(
        (x) => x.filter((y) => y.is_all || (y.value ?? []).length).length,
      );
      if (item.breakdowns.length === 0) {
        return null;
      }
      return item;
    })
    .filter(Boolean);
  return copiedPayload;
};

export const addEventNameToFilters = (
  filters: IEventFilter[][] = [],
  eventName: string,
): IEventFilter[][] => {
  const newFilter: IEventFilter = { field: 'event_name', op: 'eq', value: [eventName] };
  return eventName ? [...filters, [newFilter]] : filters;
};
